/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WaitlistEntry } from './WaitlistEntry';
import {
    WaitlistEntryFromJSON,
    WaitlistEntryFromJSONTyped,
    WaitlistEntryToJSON,
    WaitlistEntryToJSONTyped,
} from './WaitlistEntry';

/**
 * 
 * @export
 * @interface TournamentWaitlistResponse
 */
export interface TournamentWaitlistResponse {
    /**
     * 
     * @type {Array<WaitlistEntry>}
     * @memberof TournamentWaitlistResponse
     */
    teams: Array<WaitlistEntry>;
    /**
     * 
     * @type {number}
     * @memberof TournamentWaitlistResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the TournamentWaitlistResponse interface.
 */
export function instanceOfTournamentWaitlistResponse(value: object): value is TournamentWaitlistResponse {
    if (!('teams' in value) || value['teams'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function TournamentWaitlistResponseFromJSON(json: any): TournamentWaitlistResponse {
    return TournamentWaitlistResponseFromJSONTyped(json, false);
}

export function TournamentWaitlistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentWaitlistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': ((json['teams'] as Array<any>).map(WaitlistEntryFromJSON)),
        'totalCount': json['totalCount'],
    };
}

export function TournamentWaitlistResponseToJSON(json: any): TournamentWaitlistResponse {
    return TournamentWaitlistResponseToJSONTyped(json, false);
}

export function TournamentWaitlistResponseToJSONTyped(value?: TournamentWaitlistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teams': ((value['teams'] as Array<any>).map(WaitlistEntryToJSON)),
        'totalCount': value['totalCount'],
    };
}

